/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `@-webkit-keyframes spin {
  to {
    -webkit-transform: rotate(1turn);
            transform: rotate(1turn);
  }
}
@keyframes spin {
  to {
    -webkit-transform: rotate(1turn);
            transform: rotate(1turn);
  }
}
* {
  box-sizing: border-box;
}

:host {
  display: inline-block;
  vertical-align: middle;
}
:host .sp_circle {
  height: calc(18rem/14);
  width: calc(18rem/14);
  border: calc(2rem/14) solid;
  margin-top: calc(4rem/14);
  margin-right: calc(8rem/14);
  margin-bottom: calc(4rem/14);
  margin-left: calc(2rem/14);
  border-radius: 50%;
  border-color: transparent var(--davinci-color-primary,#007CC1) var(--davinci-color-primary,#007CC1) var(--davinci-color-primary,#007CC1);
  -webkit-animation: spin 1000ms infinite steps(36);
          animation: spin 1000ms infinite steps(36);
}
:host .sp_label {
  display: none;
}

:host([label]) .sp_circle {
  display: inline-block;
  vertical-align: middle;
  height: calc(14rem/14);
  width: calc(14rem/14);
}
:host([label]) .sp_label {
  display: inline-block;
  vertical-align: middle;
  color: #323c43;
  color: var(--davinci-color-text, #323c43);
  line-height: calc(22rem/14);
}

:host([below]) {
  text-align: center;
}
:host([below]) .sp_label {
  display: block;
  color: #323c43;
  color: var(--davinci-color-text, #323c43);
  line-height: calc(22rem/14);
}`;
export { style };
//# sourceMappingURL=Spinner.style.js.map